import React, { useState } from 'react';
import styles from './SharingWork.module.css';

const data = [
  {
    title: 'Custom domains',
    description: 'Stay on brand & connect your own custom domain (web address). SSL & global fast hosting (CDN) included.',
    icon: 'assets/img/sharing/domain.svg',
    slug: 'custom_domain',
    image: 'assets/img/sharing/domain-graphic.png',
    id: 1
  },
  {
    title: 'Analytics',
    description: 'Track your impact through automatic visitor analytics',
    icon: 'assets/img/sharing/analytics.svg',
    slug: 'analytics',
    image: 'assets/img/sharing/analytics-graphic.png',
    id: 2
  },
  {
    title: 'Edit mode',
    description: 'Easily edit HTML or PDF text in seconds & re-publish your work',
    icon: 'assets/img/sharing/edit.svg',
    slug: 'edit_mode',
    image: 'assets/img/sharing/edit-graphic.png',
    id: 3
  },
/*  {
    title: 'Collab mode',
    description: 'Easily edit & publish your content in seconds: Edit PDF text or HTML',
    icon: 'assets/img/sharing/community.svg',
    slug: 'collab_mode',
    image: 'assets/img/sharing/player.svg',
    id: 2
  },*/
  {
    title: 'Password protect',
    description: 'Keep your content private with a customized password login',
    icon: 'assets/img/sharing/lock.svg',
    slug: 'password_protect',
    image: 'assets/img/sharing/lock-graphic.png',
    id: 4
  },
  {
    title: 'QR Codes',
    description: 'Autogenerated QR code for every link for easy sharing',
    icon: 'assets/img/sharing/qr-code.svg',
    slug: 'qr-code',
    image: 'assets/img/sharing/qr-code-graphic.png',
    id: 5
  },
];

const SharingWork = () => {
  const [activeTab, setActiveTab] = useState('custom_domain');
  const [selectedTab, setSelectedTab] = useState(data[0]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedTab(data.find((item) => item.slug === tab));
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <p className={styles.headerText}>
          The power of the web made <span className={styles.colorText}>more user-friendly</span>
        </p>
      </div>
      <div className={styles.content}>
        <div className={styles.features}>
          {data.map((item, index) => {
            return (
              <div
                className={`${styles.feature} ${styles.transition} ${activeTab === item.slug && styles.active}`}
                key={index}
                onClick={() => handleTabClick(item.slug)}
              >
                <img
                  src={item.icon}
                  alt={item.slug}
                  className={activeTab === item.slug ? styles.iconActive : styles.imgFill}
                  height="40"
                />
                <div className={styles.featureText}>
                  <span className={activeTab === item.slug ? styles.activeTitle : styles.title}>{item.title}</span>
                  {activeTab === item.slug && <p className={styles.description}>{item.description}</p>}
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.featureImageCon}>
          <img src={selectedTab.image} alt="" width={400} />
        </div>
      </div>
    </div>
  );
};

export default SharingWork;
